import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../app/hooks";
import Footer from "../footer";
import { BackLink } from "../link";

const PrivacyPolicy = () => {
  const {t} = useTranslation(['buttons', 'general', 'legal']);
  const { place } = useAppSelector(state => state.place);

  return (
    <div className={"content container"}>
      <div className="grid maxw">
        <div className="legal-content">
          <BackLink text={t("back2", {ns: 'buttons'})} />
          <h1 className="legal-content__h1">{t("privacy_policy", {ns: 'general'})}</h1>
          <div dangerouslySetInnerHTML={{ __html: t("privacy_policy_text", {ns: 'legal'}) }}></div>
        </div>
        <Footer />
      </div>
    </div>
  )
};

export default PrivacyPolicy;